import { Logo, NavbarSidebarLayout } from '@acceso/design-system';
import clsx from 'clsx';
import { ReactNode, useEffect, useState } from 'react';

import { useMe } from '@/features/users/api/get-me';
import { useNavigationBlocker } from '@/hooks/useNavigationBlocker';
import { useNavigationBlockerStore } from '@/stores/useNavigationBlockerStore';
import { useUserStore } from '@/stores/useUserStore';

import { AppNavbarActions } from '../AppNavbarActions/AppNavbarActions';

import { useAppLayoutState } from './hooks/useAppLayoutState';

function AppLayout({ children }: { children: ReactNode }) {
  const { isMobile, menu, containerRef, userMenuState } = useAppLayoutState();
  const [showPlatformsSwitcher, setShowPlatformsSwitcher] = useState(false);
  const { setUser } = useUserStore();
  const { data: me } = useMe();
  const { shouldBlock, allowedRoutes, onExitWithoutSave } = useNavigationBlockerStore();
  useNavigationBlocker(shouldBlock, allowedRoutes, onExitWithoutSave);

  useEffect(() => {
    if (me) {
      setUser(me);
    }
  }, [me, setUser]);

  const showDifferentSidebar = !isMobile;

  return (
    <NavbarSidebarLayout
      hideNavbar={showDifferentSidebar}
      navbar={{
        logoClassName: !isMobile ? 'h-10' : 'h-8',
        end: (
          <AppNavbarActions
            userPopoverProps={userMenuState}
            showPlatformsSwitcher={showPlatformsSwitcher}
            onShowPlatformsSwitcherChange={setShowPlatformsSwitcher}
          />
        ),
        logo: '/favicon.svg',
      }}
      sidebar={{
        openWithChevron: showDifferentSidebar,
        topContent: collapse => {
          if (showDifferentSidebar) {
            return (
              <div className="flex items-center justify-center gap-2 border-2 border-b-brand-primary-30 py-2">
                {collapse ? (
                  <img src="/favicon.svg" alt="a360 logo" className="my-1 h-6 w-6" />
                ) : (
                  <Logo className={clsx('mr-size-32 max-h-[38px] max-w-[120px] shrink-0')} />
                )}
              </div>
            );
          }

          return null;
        },
        menu,
        bottomContent: collapse => {
          if (showDifferentSidebar) {
            return (
              <div
                className={clsx(
                  'flex w-full items-center justify-center gap-2 border-t border-t-text-disabled-10 py-2',
                  collapse ? 'flex-col' : 'flex-row'
                )}
              >
                <AppNavbarActions
                  userPopoverProps={userMenuState}
                  showPlatformsSwitcher={showPlatformsSwitcher}
                  onShowPlatformsSwitcherChange={setShowPlatformsSwitcher}
                  popoverPosition="top"
                />
              </div>
            );
          }

          return null;
        },
      }}
      containerRef={containerRef}
      small
      wrapperClassName="!bg-[#D9EEF74D]"
    >
      {me && <input type="hidden" name="cedroUserId" value={me.id} />}
      {children}
    </NavbarSidebarLayout>
  );
}
export { AppLayout };
